var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4253_12966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6643 0.496023C31.3271 0.158823 30.915 0.0838902 30.5403 0.233757L5.32528 10.3497C4.91315 10.4996 4.65088 10.9492 4.65088 11.3613C4.65088 11.7735 4.98808 12.1856 5.40021 12.3355L16.4529 15.7449L19.8623 26.7601C19.9747 27.1723 20.3494 27.472 20.8365 27.5095H20.8739C21.2861 27.5095 21.6607 27.2472 21.8481 26.8351L31.9266 1.62002C32.0765 1.24536 32.0015 0.795756 31.6643 0.496023Z",
    fill: "#5AB6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53837 21.8381L3.00146 27.375L4.48505 28.8586L10.022 23.3217L8.53837 21.8381Z",
    fill: "#5AB6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53691 15.8811L0 21.418L1.48359 22.9016L7.0205 17.3646L5.53691 15.8811Z",
    fill: "#5AB6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4832 24.8146L8.94629 30.3516L10.4299 31.8352L15.9668 26.2982L14.4832 24.8146Z",
    fill: "#5AB6DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4253_12966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7e0276be.svg";
export { ForwardRef as ReactComponent };